import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {
        updateMontage,
        updateHeader,
        updateCounter,
        updateBriefkasten,
        selectUploadData,
        updateDescriptionField,
        deleteUploadData,
        selectEditProduct
    } from '../../store/actions/main';
import {updateProductToMerklisteZaun, updateEditZaun} from '../../store/actions/zaune';
import {updateProductToMerklisteTore, updateEditTore} from '../../store/actions/tore';
import {updateEditPforte, updateProductToMerklistePforte} from '../../store/actions/pforten';
import {updateProductToMerklisteGelaender} from '../../store/actions/gelaender';
import {updateProductToMerklisteVordaecher} from '../../store/actions/vordaecher';
import {updateProductToMerklisteStahltreppe, updateEditStahltreppe} from '../../store/actions/stahltreppen';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import {Link} from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import musterbeispiel from '../../../assets/images/own_modell/musterbeispiel.svg';
import Kontaktformular from "../../module/kontakformular";
// import DescriptionIcon from '@material-ui/icons/Description';
import Button from '@material-ui/core/Button';
import ModalPopUp from '../../module/modalPopUp';
import {PrintAngebotGesamt} from '../../module/printAngebotGesamt';
import SendIcon from '@material-ui/icons/Send';
// import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
// import { Satellite } from "@material-ui/icons";

const Merkliste = (props) => {

    let [showModalKontakt, setShowModalKontakt] = useState(false);
    // let [description, selectDescription] = useState('');
    // let empty_file = '';
    // let [image_data, slectImageData] = useState('');
    // let [file_name, selectFilename] = useState('');
    // let [file_name_button, selectFilenameButton] = useState('');
    // let [file_type, selectFiletype] = useState('');
    // let [showModal, updateShowModal] = useState(false);

    const closeModalKontakt = () => setShowModalKontakt(false);
    // const selectShowModal = () => updateShowModal(true);
    // const closeModal = () => updateShowModal(false);


   useEffect(() => {

      props.updateHeader('Merkliste');
      updateItems();
   })

   const updateItems = () => {
        //selectDescription(props.description);
        //slectImageData(props.image_data);

        //update file data
        // if(props.file_data) {
        //     let file_data = props.file_data;
        //     let file_type = props.file_data.type;
        //     file_type = file_type.split('/')[1];
        //     let file_name = '';
        //     let file_name_button = '';
        //     file_name = file_data.name;
        //     file_name = file_name.split('.').shift();
        //     file_name_button = file_data.name;
        //     file_name_button =  file_name_button.split('.').shift();
        //     if(file_name_button.length > 20) {
        //         file_name_button = file_name_button.slice(0,17);
        //         file_name_button+= '...';
        //     }
        //     selectFilename(file_name);
        //     selectFilenameButton(file_name_button);
        //     selectFiletype(file_type);
        // }

   }

   const deleteProduct = ev => {
       let product = ev.currentTarget.getAttribute('product');
       let delete_index = ev.currentTarget.getAttribute('index');

       switch (product) {
        case 'zaun':
            props.updateProductToMerklisteZaun();
        break;
        case 'tor':
            props.updateProductToMerklisteTore(delete_index);
        break;
        case 'pforten':
            props.updateProductToMerklistePforte();
        break;
        case 'stahlgelaender':
            props.updateProductToMerklisteGelaender(delete_index);
        break;
        case 'edelstahlgelaender':
            props.updateProductToMerklisteGelaender(delete_index);
        break;
        case 'gelaender_glas':
            props.updateProductToMerklisteGelaender(delete_index);
        break;
        case 'edelstahlgelaender_ohne_fuellung':
            props.updateProductToMerklisteGelaender(delete_index);
        break;
        case 'vordaecher':
            props.updateProductToMerklisteVordaecher(delete_index);
        break;
        case 'stahltreppe':
            props.updateProductToMerklisteStahltreppe();
        break;
        default:
            return product;
        }

       props.updateCounter('dec');
   }

   const editProduct = ev => {
       let product = ev.currentTarget.getAttribute('product');
       let edit_index = ev.currentTarget.getAttribute('index');

        let objectOfEditProduct = {
            index: edit_index,
            titel: ev.currentTarget.getAttribute('titel')
        }

        console.log('objectOfEditProduct', objectOfEditProduct);

        switch (product) {
            case 'zaun':
               props.updateEditZaun();
            break;
            case 'tor':
                props.selectEditProduct(objectOfEditProduct);
            break;
            case 'pforten':
                props.updateEditPforte();
            break;
            case 'gelaender':
                props.selectEditProduct(objectOfEditProduct);
            break;
            case 'vordaecher':
                props.selectEditProduct(objectOfEditProduct);
            break;
            case 'stahltreppe':
                props.updateEditStahltreppe();
            break;
            default:
                return product;
        }


   }

   const openKontaktformular = () => {
        setShowModalKontakt(true);
   }

//    const selectUploadData = ev => {
//         ev.preventDefault();
//         let reader = new FileReader();
//         let file = ev.target.files[0];

//         reader.onloadend = () => {
//         let uploadObject = {
//             file: file,
//             image: reader.result
//         }
//         props.selectUploadData(uploadObject);
//         updateItems();
//         }
//         reader.readAsDataURL(file);
//     }

//   const updateDescription = ev => {
//     props.updateDescriptionField(ev.target.value);
//     updateItems();
//   }


   let productData = [];
   let products = [props.zaun_data,
                    props.tore_data[0],
                    props.tore_data[1],
                    props.pforten_data,
                    props.stahltreppen_data,
                    props.gelaender_data[0],
                    props.gelaender_data[1],
                    props.gelaender_data[2],
                    props.gelaender_data[3],
                    props.vordaecher_data[0],
                    props.vordaecher_data[1],
                    props.vordaecher_data[2],
                    props.vordaecher_data[3],
                ];

   products.forEach((elem, index) => {
        if (elem.is_merkliste) {
            productData.push(elem);
            //productData.splice(0, 0, productData.splice(productData.length-1, 1)[0]);
        }
   })

   console.log('PRODUCT DATA', productData);


   return (
           <div id="merkliste_wrapper">
                {props.counter>0?
                <>
                    <h2 className="merkliste_header">Übersicht der ausgewählten Produkte</h2>
                    {productData.map((elem, index) => {
                        return (
                        <div className="main-wrapper" key={index}>
                            {elem.category === 'Zaun'?
                            <>
                                <h3 className='product_categorie_titel'>{elem.category}</h3>
                                <div className='product_wrapper zaun_product_wrapper'>
                                    <Link to='/zaune' className='link'>
                                        <div onClick={editProduct} product="zaun" titel='Zaun' className='titel_wrapper'>
                                                <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Zaunmuster'} />
                                                <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                        </div>
                                    </Link>
                                    <div className='product_desc_wrapper'>
                                        <ul>
                                            {elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?<li>Form: {elem.modell[0].form}</li>:''}
                                            <li>Höhe: {elem.dimensions[0].total_dimension_height}cm</li>
                                            {elem.dimensions[0].dimension === 'Gesamt'?
                                                <li>Gesamtlänge: {elem.dimensions[0].total_dimension_width}m</li>:''
                                            }
                                            {elem.dimensions[0].dimension === 'Einzeln'?
                                                <>
                                                    <li>Zaunfeld 1: (Länge: {elem.dimensions[0].single_width}cm,
                                                        Stückzahl: {elem.dimensions[0].single_piece})
                                                    </li>
                                                    {elem.dimensions[0].kind_dimension === 'Die Elemente sind unterschiedlich breit'?
                                                            elem.dimensions[0].single_fields.map((field, field_index) => (
                                                            <li key={field_index}>Zaunfeld {field_index+2}: (Länge: {field.width}cm, Stückzahl: {field.piece})</li>
                                                            ))
                                                        :''
                                                    }
                                                </>
                                                :''
                                            }
                                            <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                            <li>Zaunspitzen: {elem.spitzen[0].spitze}</li>
                                            <li>Pfosten: {elem.pfosten[0].ispfosten?'Keine Pfosten':'(Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm)'}</li>
                                        </ul>
                                    </div>
                                    <div className='controll_wrapper'>
                                                    <DeleteForeverIcon onClick={deleteProduct} product="zaun" className='delete_icon' />
                                                    <Link to='/zaune' className='link'><EditIcon onClick={editProduct} product="zaun" titel='Zaun' className='edit_icon' /></Link>
                                    </div>
                                </div>
                            </>:''}
                            {elem.category === 'Schiebetor'?
                            <>
                                <h3 className='product_categorie_titel'>{elem.category}</h3>
                                <div className='product_wrapper fluegeltor_product_wrapper'>
                                    <Link to={'/tore'} className='link'>
                                        <div onClick={editProduct} product="tor" titel={elem.modell[0].titel} index={0} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Flügeltormuster'} />
                                            <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                        </div>
                                    </Link>
                                    <div className='product_desc_wrapper'>
                                        <ul>
                                            {elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?<li>Form: {elem.modell[0].form}</li>:''}
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            <li>Gesamtlänge: {elem.dimensions[0].width}cm</li>
                                            <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                            <li>Zaunspitzen: {elem.spitzen[0].spitze}</li>
                                            <li>Pfosten: ({!elem.pfosten[0].iskappen?'Keine Pfosten':'Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm'})</li>
                                            <li>Antrieb: {elem.antrieb}</li>
                                            <li>Öffnungsrichtung: {elem.direction}</li>
                                        </ul>
                                    </div>
                                    <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="tor" index={0} className='delete_icon' />
                                        <Link to={'/tore'} className='link'><EditIcon onClick={editProduct} product="tor" titel={elem.modell[0].kind} index={0} className='edit_icon' /></Link>
                                    </div>
                                </div>
                            </>:''}
                            {elem.category === 'Flügeltor'?
                            <>
                                <h3 className='product_categorie_titel'>{elem.category}</h3>
                                <div className='product_wrapper schiebetor_product_wrapper'>
                                    <Link to={'/tore'} className='link'>
                                        <div onClick={editProduct} product="tor" titel={elem.modell[0].titel} index={1} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Schiebetormuster'} />
                                             <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                         </div>
                                     </Link>
                                     <div className='product_desc_wrapper'>
                                         <ul>
                                             {elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?<li>Form: {elem.modell[0].form}</li>:''}
                                             <li>Höhe: {elem.dimensions[0].height}cm</li>
                                             <li>Gesamtlänge: {elem.dimensions[0].width}cm</li>
                                             <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                             <li>Zaunspitzen: {elem.spitzen[0].spitze}</li>
                                             <li>Pfosten: ({!elem.pfosten[0].iskappen?'Keine Pfosten':'Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm'})</li>
                                             <li>Antrieb: {elem.antrieb}</li>
                                             <li>Öffnungsrichtung: {elem.direction}</li>
                                         </ul>
                                     </div>
                                     <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="tor" index={1} className='delete_icon' />
                                        <Link to={'/tore'} className='link'><EditIcon onClick={editProduct} product="tor" titel={elem.modell[0].titel} index={1} className='edit_icon' /></Link>
                                    </div>
                                 </div>
                             </> :''}
                            {elem.category === 'Pforte'?
                            <>
                                    <h3 className='product_categorie_titel'>Pforte</h3>
                                    <div className='product_wrapper pforte_product_wrapper'>
                                        <Link to='/pforten' className='link'>
                                            <div onClick={editProduct} product="pforten"  titel='Pforte' className='titel_wrapper'>
                                                <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Pfortenmuster'} />
                                                <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                            <ul>
                                                {elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?<li>Form: {elem.modell[0].form}</li>:''}
                                                <li>Höhe: {elem.dimensions[0].height}cm</li>
                                                <li>Gesamtlänge: {elem.dimensions[0].width}cm</li>
                                                <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                                <li>Zaunspitzen: {elem.spitzen[0].spitze}</li>
                                                <li>Pfosten: {elem.pfosten[0].ispfosten?'Keine Pfosten':'(Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm)'}</li>
                                                <li>Öffnungsrichtung: {elem.direction}</li>
                                            </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                            <DeleteForeverIcon onClick={deleteProduct} product="pforten" className='delete_icon' />
                                            <Link to='/pforten' className='link'><EditIcon onClick={editProduct} product="pforten" titel='Pforte' className='edit_icon' /></Link>
                                        </div>
                                    </div>
                                </> :''}
                            {elem.category === 'Stahltreppe'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper stahltreppen_product_wrapper'>
                                        <Link to='/stahltreppe' className='link'>
                                            <div onClick={editProduct} product="stahltreppe" titel='Stahltreppe' className='titel_wrapper'>
                                                <img className="img_stahltreppen"
                                                src={elem.gelaender[0].img} alt={elem.titel} />
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                            <ul>
                                                <li>{elem.gelaender[0].gelaender_type}</li>
                                                <li>Muster für Geländer: {elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</li>
                                                {/* <li>Form des Handlaufs: {elem.handlauf[0].handlauf_form}</li>
                                                <li>Endkappe des Handlaufs: {elem.handlauf[0].endkappe}</li> */}
                                                <li>Geschosshöhe: {elem.geschosshoehe[0].height}cm {elem.geschosshoehe[0].height>=83?`(Stufen: ${elem.geschosshoehe[0].stufen} St.)`:''} </li>
                                                <li>Breite der Stufen: {elem.stufenBreite}</li>
                                                {elem.podest[0].isPodest === 'nein'?<li>Podest: Kein Podest</li>:<li>Podestlänge: {elem.podest[0].podestWidth}cm</li>}
                                                <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                            </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                            <DeleteForeverIcon onClick={deleteProduct} product='stahltreppe'  className='delete_icon' />
                                            <Link to='/stahltreppe' className='link'><EditIcon onClick={editProduct} product="stahltreppe" titel='Stahltreppe' className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                           {elem.category === 'Stahlgeländer'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper stahlgelaender_product_wrapper'>
                                        <Link to='/gelaender' className='link'>
                                            <div onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={0} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Stahlgeländermuster'} />
                                             <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Grundriss: {elem.layout}</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            {elem.dimensions[0].kind_dimension === 'Gesamt'?
                                                <li>Gesamtlänge: {elem.dimensions[0].width_total}m</li>
                                                :
                                                <>
                                                    {elem.layout === 'I-Form'?<li>Länge des Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm</li>:''}
                                                    {elem.layout === 'L-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'U-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'Sonderform'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    {elem.dimensions[0].single_elements.length > 0?
                                                                                        elem.dimensions[0].single_elements.map((field, field_index) => (
                                                                                            <span key={field_index}> Länge des {field_index+4}. Elements: {field.width}cm,<br></br></span>
                                                                                        ))
                                                                                        :''
                                                                                    }
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                            </li>:''}
                                                </>
                                            }
                                           <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt' || elem.colors[0].kind_of_color === 'Keine Beschichtung'?
                                                 elem.colors[0].kind_of_color:elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                            <li>Befestigungsart: {elem.befestigungsart}</li>
                                            <li>Form des Handlaufs: {elem.form_handrail[0].handtrail_form}</li>
                                            <li>Endkappe: {elem.form_handrail[0].endkappe}</li>
                                            <li>Form der Pfosten: {elem.pfosten_form}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="stahlgelaender" index={0} className='delete_icon' />
                                        <Link to='/gelaender' className='link'><EditIcon onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={0} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Edelstahlgeländer'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper stahlgelaender_product_wrapper'>
                                        <Link to='/gelaender' className='link'>
                                            <div onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={1} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Edelstahlgeländermuster'} />
                                             <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Grundriss: {elem.layout}</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            {elem.dimensions[0].kind_dimension === 'Gesamt'?
                                                <li>Gesamtlänge: {elem.dimensions[0].width_total}m</li>
                                                :
                                                <>
                                                    {elem.layout === 'I-Form'?<li>Länge des Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm</li>:''}
                                                    {elem.layout === 'L-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'U-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'Sonderform'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    {elem.dimensions[0].single_elements.length > 0?
                                                                                        elem.dimensions[0].single_elements.map((field, field_index) => (
                                                                                            <span key={field_index}> Länge des {field_index+4}. Elements: {field.width}cm,<br></br></span>
                                                                                        ))
                                                                                        :''
                                                                                    }
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                            </li>:''}
                                                </>
                                            }
                                            <li>Befestigungsart: {elem.befestigungsart}</li>
                                            <li>Form des Handlaufs: {elem.form_handrail[0].handtrail_form}</li>
                                            <li>Endkappe: {elem.form_handrail[0].endkappe}</li>
                                            <li>Form der Pfosten: {elem.pfosten_form}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="stahlgelaender" index={1} className='delete_icon' />
                                        <Link to='/gelaender' className='link'><EditIcon onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={1} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Geländer mit Glas'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper stahlgelaender_product_wrapper'>
                                        <Link to='/gelaender' className='link'>
                                            <div onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={2} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Muster mit Glas'} />
                                             <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Grundriss: {elem.layout}</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            {elem.dimensions[0].kind_dimension === 'Gesamt'?
                                                <li>Gesamtlänge: {elem.dimensions[0].width_total}m</li>
                                                :
                                                <>
                                                    {elem.layout === 'I-Form'?<li>Länge des Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm</li>:''}
                                                    {elem.layout === 'L-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'U-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'Sonderform'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    {elem.dimensions[0].single_elements.length > 0?
                                                                                        elem.dimensions[0].single_elements.map((field, field_index) => (
                                                                                            <span key={field_index}> Länge des {field_index+4}. Elements: {field.width}cm,<br></br></span>
                                                                                        ))
                                                                                        :''
                                                                                    }
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                            </li>:''}
                                                </>
                                            }
                                            <li>Oberfläche: {elem.colors[0].kind_of_color === 'Nur feuerverzinkt' || elem.colors[0].kind_of_color === 'Keine Beschichtung'?
                                                elem.colors[0].kind_of_color : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}</li>
                                            <li>Befestigungsart: {elem.befestigungsart}</li>
                                            <li>Form des Handlaufs: {elem.form_handrail[0].handtrail_form}</li>
                                            <li>Endkappe: {elem.form_handrail[0].endkappe}</li>
                                            <li>Form der Pfosten: {elem.pfosten_form}</li>
                                            <li>Glastönung: {elem.glasart}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="stahlgelaender" index={2} className='delete_icon' />
                                        <Link to='/gelaender' className='link'><EditIcon onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={2} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Treppengeländer Edelstahl'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper stahlgelaender_product_wrapper'>
                                        <Link to='/gelaender' className='link'>
                                            <div onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={3} className='titel_wrapper'>
                                            <img src={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].img:musterbeispiel} alt={elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?elem.modell[0].titel:'Eigenes Muster für Treppengeländer'} />
                                             <p className='product_titel'>{elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}</p>
                                            </div>
                                        </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Grundriss: {elem.layout}</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            {elem.dimensions[0].kind_dimension === 'Gesamt'?
                                                <li>Gesamtlänge: {elem.dimensions[0].width_total}m</li>
                                                :
                                                <>
                                                    {elem.layout === 'I-Form'?<li>Länge des Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm</li>:''}
                                                    {elem.layout === 'L-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'U-Form'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                                </li>:''}
                                                    {elem.layout === 'Sonderform'?<li>Länge des 1. Elements: {elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm,<br></br>
                                                                                    Länge des 2. Elements: {elem.dimensions[0].width_2 > 0?elem.dimensions[0].width_2:'0'}cm,<br></br>
                                                                                    Länge des 3. Elements: {elem.dimensions[0].width_3 > 0?elem.dimensions[0].width_3:'0'}cm,<br></br>
                                                                                    {elem.dimensions[0].single_elements.length > 0?
                                                                                        elem.dimensions[0].single_elements.map((field, field_index) => (
                                                                                            <span key={field_index}> Länge des {field_index+4}. Elements: {field.width}cm,<br></br></span>
                                                                                        ))
                                                                                        :''
                                                                                    }
                                                                                    (Gesamtlänge: {elem.dimensions[0].width_total}cm)
                                                                            </li>:''}
                                                </>
                                            }
                                            <li>Befestigungsart: {elem.befestigungsart}</li>
                                            <li>Form des Handlaufs: {elem.form_handrail[0].handtrail_form}</li>
                                            <li>Endkappe: {elem.form_handrail[0].endkappe}</li>
                                            <li>Form der Pfosten: {elem.pfosten_form}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="stahlgelaender" index={3} className='delete_icon' />
                                        <Link to='/gelaender' className='link'><EditIcon onClick={editProduct} product="gelaender" titel={elem.modell[0].titel} index={3} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Glasvordach freitragend'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper'>
                                    <Link to='/vordaecher' className='link'>
                                        <div onClick={editProduct} product="vordaecher" titel={elem.titel} index={0} className='titel_wrapper'>
                                            <img className="img_vordaecher" src={elem.product_img} alt={elem.titel} />
                                            <p className='product_titel'>{elem.titel}</p>
                                        </div>
                                    </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Breite: {elem.dimensions[0].width}cm</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            <li>Glastönung: {elem.glasart}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="vordaecher" index={0} className='delete_icon' />
                                        <Link to='/vordaecher' className='link'><EditIcon onClick={editProduct} product="vordaecher" titel={elem.titel} index={0} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Glasvordach Trave'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper'>
                                    <Link to='/vordaecher' className='link'>
                                        <div onClick={editProduct} product="vordaecher" titel={elem.titel} index={1} className='titel_wrapper'>
                                            <img className="img_vordaecher" src={elem.product_img} alt={elem.titel} />
                                            <p className='product_titel'>{elem.titel}</p>
                                        </div>
                                    </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Breite: {elem.dimensions[0].width}cm</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            <li>Glastönung: {elem.glasart}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="vordaecher" index={1} className='delete_icon' />
                                        <Link to='/vordaecher' className='link'><EditIcon onClick={editProduct} product="vordaecher" titel={elem.titel} index={1} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Glasvordach mit Zugstangen'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper'>
                                    <Link to='/vordaecher' className='link'>
                                        <div onClick={editProduct} product="vordaecher" titel={elem.titel} index={2} className='titel_wrapper'>
                                            <img className="img_vordaecher" src={elem.product_img} alt={elem.titel} />
                                            <p className='product_titel'>{elem.titel}</p>
                                        </div>
                                    </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Breite: {elem.dimensions[0].width}cm</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            <li>Glastönung: {elem.glasart}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="vordaecher" index={2} className='delete_icon' />
                                        <Link to='/vordaecher' className='link'><EditIcon onClick={editProduct} product="vordaecher" titel={elem.titel} index={2} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                            {elem.category === 'Glasvordach mit Pfosten'?
                            <>
                                    <h3 className='product_categorie_titel'>{elem.category}</h3>
                                    <div className='product_wrapper'>
                                    <Link to='/vordaecher' className='link'>
                                        <div onClick={editProduct} product="vordaecher" titel={elem.titel} index={3} className='titel_wrapper'>
                                            <img className="img_vordaecher" src={elem.product_img} alt={elem.titel} />
                                            <p className='product_titel'>{elem.titel}</p>
                                        </div>
                                    </Link>
                                        <div className='product_desc_wrapper'>
                                        <ul>
                                            <li>Breite: {elem.dimensions[0].width}cm</li>
                                            <li>Höhe: {elem.dimensions[0].height}cm</li>
                                            <li>Pfosten: {elem.pfosten}</li>
                                            <li>Glastönung: {elem.glasart}</li>
                                        </ul>
                                        </div>
                                        <div className='controll_wrapper'>
                                        <DeleteForeverIcon onClick={deleteProduct} product="vordaecher" index={3} className='delete_icon' />
                                        <Link to='/vordaecher' className='link'><EditIcon onClick={editProduct} product="vordaecher" titel={elem.titel} index={3} className='edit_icon' /></Link>
                                        </div>
                                    </div>
                            </>:''}
                    </div>
                    )})}

                </>
                :
                    <>
                        <h2 className="merkliste_header">Sie haben keine Produkte ausgewählt</h2>
                        <Link className="link" to="/"><Button className="button">Zurück zur Übersicht</Button></Link>
                    </>
                }

                {/*Briefkasten */}
                    {props.tore_data[0].is_merkliste || props.tore_data[1].is_merkliste?
                        <div className="another_product_wrapper">
                            <h3>Brauchen Sie noch einen Briefkasten?</h3>
                            <div className='item-wrapper'>
                                <TextField
                                    className="textfield-input"
                                    label="Bitte wählen"
                                    select
                                    rowsMax={1}
                                    value={props.briefkasten_select}
                                    onChange={props.updateBriefkasten}
                                >
                                    {props.briefkasten_option.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>
                                            {option.value}
                                    </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>
                    :''
                }
                {/* Monatge */}
                {/* {props.zaun_data.is_merkliste || fluegelTorData.is_merkliste || schiebeTorData.is_merkliste || props.stahltreppen_data.is_merkliste?
                    <div className="another_product_wrapper">
                        <h3>Sollen die Elemente vorort montiert werden?</h3>
                        <div className='item-wrapper'>
                            <TextField
                                className="textfield-input"
                                label="Bitte wählen"
                                select
                                type="text"
                                rowsMax={1}
                                value={props.montage_select}
                                onChange={props.updateMontage}
                            >
                            {props.montage_option.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    {option.value}
                                </MenuItem>
                            ))}
                            </TextField>
                        </div>
                    </div>
                :''} */}
                {/* <div className="contact_wrapper">
                    <h2>
                        Hier können Sie uns Ihr Anliegen mit einer
                        detalierten Beschreibung und ggf. einer Skizze mitteilen.
                    </h2>
                    <div className='contact_description_wrapper'>
                        <TextField
                            className="outlined-multiline-static"
                            type="text"
                            label="Ihr Anliegen:"
                            rowsMax={10}
                            multiline
                            variant="outlined"
                            value={description}
                            name="description"
                            onChange={updateDescription}
                            >
                        </TextField>
                        <Button className='addButton' component="label" startIcon={<DescriptionIcon />}>
                            Datei auswählen
                            <input type="file" onChange={selectUploadData} value={empty_file} hidden />
                        </Button>
                        {image_data?
                            <Button startIcon={<PhotoLibraryIcon onClick={selectShowModal}/>} className='image_data_button'><DeleteForeverIcon className='delete_icon' onClick={props.deleteUploadData} /> {file_name_button}</Button>
                        :''
                        }
                        <ModalPopUp
                            title={file_name}
                            component={
                                file_type !=='pdf'?
                                <img src={image_data} alt={file_name} className='image_data'/>
                                :
                                <iframe
                                        id='iframe_data'
                                        frameBorder="0"
                                        allowFullScreen
                                        src={image_data}
                                        type='application/pdf'
                                        title={file_name}
                                />
                            }
                            showModal={showModal}
                            hideModal={closeModal}
                        />
                    </div>

                </div>*/}
                {props.counter >0?
                <>
                    <PrintAngebotGesamt
                        productData={productData}
                        briefkasten={props.briefkasten_select}
                        gelaenderData={props.gelaender_data}
                        className='button'
                    />
                    <Button
                        onClick={openKontaktformular}
                        className="button"
                        startIcon={<SendIcon />}
                        >Anfrage senden
                    </Button>
                </>
                :null}
                <ModalPopUp
                    title='Kontaktanfrage'
                    component={ <Kontaktformular />}
                    showModal={showModalKontakt}
                    hideModal={closeModalKontakt}
                />
                </div>
   )
}

const mapStateToProps = state => {
    return {
        url: state.mainReducer.url,
        modell_index: state.zauneReducer.modell_index,
        modell_type_index: state.zauneReducer.modell_type_index,
        //Zäune
        zaun_data: state.zauneReducer.data,
        //Tore
        tore_data: state.toreReducer.data,
        tore_muster: state.toreReducer.muster,
        //Pforten
        pforten_data: state.pfortenReducer.data,
        //Geländer
        gelaender_data: state.gelaenderReducer.data,
        //Vordächer
        vordaecher_data: state.vordaecherReducer.data,
        //Stahltreppen
        stahltreppen_data: state.stahltreppenReducer.data,
        //Briefkasten
        briefkasten_select: state.mainReducer.data[0].briefkasten[0].briefkasten_select,
        briefkasten_option: state.mainReducer.data[0].briefkasten[0].briefkasten_option,
        //Montage
        montage_select: state.mainReducer.data[2].montage[0].montage_select,
        montage_option: state.mainReducer.data[2].montage[0].montage_option,
        //Contact
        description: state.mainReducer.contact[1].description,
        image_data: state.mainReducer.contact[2].uploadfile[0].image,
        file_data: state.mainReducer.contact[2].uploadfile[0].file,
        counter: state.mainReducer.counter
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      //Briefkasten
      updateBriefkasten: ev => dispatch(updateBriefkasten(ev)),
      //Montage
      updateMontage: ev => dispatch(updateMontage(ev)),
      //Header
      updateHeader: ev => dispatch(updateHeader(ev)),
      //Zäune
      updateProductToMerklisteZaun: () => dispatch(updateProductToMerklisteZaun()),
      updateEditZaun: () => dispatch(updateEditZaun()),
      //Tore
      updateProductToMerklisteTore: ev => dispatch(updateProductToMerklisteTore(ev)),
      updateEditTore: ev => dispatch(updateEditTore(ev)),
      //Pforten
      updateEditPforte: ev => dispatch(updateEditPforte(ev)),
      updateProductToMerklistePforte: () => dispatch(updateProductToMerklistePforte()),
      //Geländer
      updateProductToMerklisteGelaender: ev => dispatch(updateProductToMerklisteGelaender(ev)),
      //Vordächer
      updateProductToMerklisteVordaecher: ev => dispatch(updateProductToMerklisteVordaecher(ev)),
      //Stahltreppen
      updateProductToMerklisteStahltreppe: () => dispatch(updateProductToMerklisteStahltreppe()),
      updateEditStahltreppe: ev => dispatch(updateEditStahltreppe(ev)),
      //Main
      selectEditProduct: ev => dispatch(selectEditProduct(ev)),
      updateCounter: ev => dispatch(updateCounter(ev)),
      selectUploadData: ev => dispatch(selectUploadData(ev)),
      updateDescriptionField: ev => dispatch(updateDescriptionField(ev)),
      deleteUploadData: () => dispatch(deleteUploadData())
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Merkliste);
